import { render, staticRenderFns } from "./BannerPC_HK09606.vue?vue&type=template&id=52494e00&scoped=true"
import script from "./BannerPC_HK09606.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerPC_HK09606.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BannerPC_HK09606.vue?vue&type=style&index=0&id=52494e00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52494e00",
  null
  
)

export default component.exports